(function () {
    'use strict';

    function AdminNotificationCtrl(restangular, toastr, appData) {
        var vm = this;

        restangular
            .one('application')
            .one('notification')
            .get()
            .then(function (response) {
                vm.notification = response;
            });

        vm.saveNotification = saveNotification;
        vm.clearNotification = clearNotification;

        /////////////////////////////////////
        function saveNotification() {
            vm.notification.save().then(function() {
                    toastr.info('Notification has been updated.', 'Updated');
                    appData.notification = vm.notification;
                },
                function() {
                    toastr.error('Unable to save notification.', 'Error');
                });
        }

        function clearNotification() {
            if (vm.notification) {
                vm.notification.title = null;
                vm.notification.description = null;
                saveNotification();
            }
        }
    };

    angular
        .module('app')
        .controller('AdminNotificationCtrl', ['Restangular', 'toastr', 'appData', AdminNotificationCtrl]);

})();